import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App'; // Remove the .tsx extension
import '@fontsource/plus-jakarta-sans/400.css';
import '@fontsource/plus-jakarta-sans/500.css';
import '@fontsource/plus-jakarta-sans/600.css';
import '@fontsource/plus-jakarta-sans/700.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import './index.css';
import './styles/mobile.css'; // Add this line for mobile optimizations
import * as Sentry from "@sentry/react";

// Initialize Sentry BEFORE rendering the app
Sentry.init({
  dsn: "https://d053bebfac9ec224314bf0e17ff92057@o4509343859408896.ingest.de.sentry.io/4509343864127568",
  // Setting this option to true will send default PII data to Sentry
  sendDefaultPii: true
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);